import { Modal } from "@design-lab/shared/ui";
import { X } from "lucide-react";
import { TransferImageSelector } from "./TransferImageSelector";

interface UploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFileDrop: (files: File[]) => Promise<void>;
  onOpenLibrary: () => void;
  onCanvaFilesReady?: (files: File[]) => Promise<void>;
  isLoggedIn: boolean;
  isDesktop: boolean;
}

export function UploadModal({
  isOpen,
  onClose,
  onFileDrop,
  onOpenLibrary,
  onCanvaFilesReady,
  isLoggedIn,
  isDesktop
}: UploadModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-[545px] px-6 pt-4"
      title="Upload"
      description="Upload images to transfers lab"
    >
      {/* Header */}
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">Upload</h2>
        <button
          type="button"
          onClick={onClose}
          className="flex size-6 items-center justify-center rounded hover:bg-gray-100"
          aria-label="Close"
          data-testid="upload-modal-close"
        >
          <X className="size-6 text-gray-500" />
        </button>
      </div>

      {/* Body */}
      <div className="h-[250px]">
        <TransferImageSelector
          title="Upload Artwork"
          onFileDrop={async files => {
            await onFileDrop(files);
            onClose();
          }}
          isLoggedIn={isLoggedIn}
          isDesktop={isDesktop}
          allowMultipleFiles={true}
          onLibraryClick={() => {
            onClose();
            onOpenLibrary();
          }}
          {...(onCanvaFilesReady && {
            onCanvaFilesReady: async (files: File[]) => {
              await onCanvaFilesReady(files);
              onClose();
            }
          })}
        />
      </div>
    </Modal>
  );
}
